export default function () {
  /* 表格列头 */
  return [
    { label: "序号", type: "index", width: 80 },
    { label: "模版ID", prop: "id" },
    {
      label: "自动发送时间周期",
      prop: "cycle_id",
      width: 180,
      slots: "cycle_id",
    },
    { label: "消息模版名称", prop: "template_name", width: 200 },
    // { label: "公众号ID", prop: "account_id" },
    { label: "消息模版code", prop: "template_code", width: 300 },
    { label: "跳转url", prop: "url", width: 200 },
    { label: "跳转小程序", prop: "xcx_appid", width: 200 },
    { label: "跳转小程序页面路径", prop: "pagepath", width: 200 },

    // {
    //   label: "创建时间",
    //   prop: "createTime",
    //   width: 180,
    //   // slots: "state",
    // },
    {
      label: "操作",
      prop: "operation",
      width: 150,
      slots: "operation",
      fixed: "right",
    },
  ];
}
